import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "vip-container" }
const _hoisted_2 = { class: "table-title" }
const _hoisted_3 = { class: "bottom_text" }
const _hoisted_4 = ["innerHTML"]

import CustomHeader from '@/themes/themeFour/components/common/customHeader.vue';
import VIPTableView from './vipTableView.vue';
import { computed, ref, watch } from 'vue';
import VipHistoryPopup from './vipHistoryPopup.vue';
import { VipData } from '@/view/vip/supportScript';
import { TAB_LIST_THREE } from '@/view/vip/supportScript';
import VipCardUI from './vipCardUI.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipViewContent',
  props: {
    dataSet: {},
    isTabView: { type: Boolean }
  },
  emits: ['vIPClaim', 'update:active'],
  setup(__props: any, { emit: __emit }) {

const progressPercentage = computed(() => 6500 * 100 / 10000);
const active = ref(0);
const historyRef = ref()
const vipConfigData = ref()
const tabList = computed(() => {
    var TabList = [...TAB_LIST_THREE]
    if (props.dataSet.vipConfigData?.rewardsStatus.isDailyReward !== 1) {
        TabList = TAB_LIST_THREE.filter(item => item.id !== 2)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isWeeklyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 3)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isMonthlyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 4)
    }
    return TabList
});
const showHistory = () => {
    historyRef.value.open()
}
const props = __props
const emit = __emit

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})


return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isTabView)
      ? (_openBlock(), _createBlock(CustomHeader, {
          key: 0,
          text: _ctx.$t('vip.title'),
          showHistory: true,
          onOpenHistoryPopup: showHistory
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "subContainer",
        style: _normalizeStyle({ padding: _ctx.isTabView ? '0px 0px 25px' : '70px 0px 25px' })
      }, [
        _createVNode(VipCardUI, {
          onClaimVIP: VIPClaim,
          remainRewards: _ctx.dataSet.remainRewards
        }, null, 8, ["remainRewards"]),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('vip.tireList')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: _normalizeClass(["tabs", { 'tabs-top-zero': _ctx.isTabView }])
          }, [
            _createVNode(_component_van_tabs, {
              id: "vipTabs",
              ellipsis: false,
              active: active.value,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (index) => {
                  return (_openBlock(), _createBlock(_component_van_tab, {
                    title: _ctx.$t(index.name),
                    key: index.id,
                    name: index.id
                  }, null, 8, ["title", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"])
          ], 2),
          _createVNode(VIPTableView, {
            activeNo: _ctx.dataSet.active,
            tableData: _ctx.dataSet.tabelData,
            isTabView: _ctx.isTabView,
            activeData: _ctx.dataSet.vipConfigData?.rewardsStatus,
            vipRewardInfo: _ctx.dataSet.VIPRewardsInfo,
            nextLevelRecord: _ctx.dataSet.nextLevelRecord,
            nextLevel: _ctx.dataSet.nextLevel
          }, null, 8, ["activeNo", "tableData", "isTabView", "activeData", "vipRewardInfo", "nextLevelRecord", "nextLevel"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('vip.vipActivityInstructions')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activity_intro, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index,
              innerHTML: item
            }, null, 8, _hoisted_4))
          }), 128))
        ])
      ], 4)
    ]),
    _createVNode(VipHistoryPopup, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ], 64))
}
}

})